import { render, staticRenderFns } from "./ModalProductTable.vue?vue&type=template&id=5072ebac&scoped=true"
import script from "./ModalProductTable.vue?vue&type=script&lang=js"
export * from "./ModalProductTable.vue?vue&type=script&lang=js"
import style0 from "./ModalProductTable.vue?vue&type=style&index=0&id=5072ebac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072ebac",
  null
  
)

export default component.exports